import React from 'react';
import PropTypes from 'prop-types';
import { Text } from './title.css';
import Logo from '../../images/logo.png'

const Title = ({ children, as = 'span', size }) => {
  return (
    <Text as={as} size={size}>
      <img style={{ height: '25px' }} alt='logo' src={Logo} />
    </Text>
  );
};

Title.propTypes = {
  children: PropTypes.string.isRequired,
  as: PropTypes.string,
  size: PropTypes.oneOf(['large']),
};

export default Title;
